<sc-data-set-tile>
    <div class="tile">
        <sc-flex [centered]="true" [fitHeight]="true">
            {{profile.name}}
        </sc-flex>
    </div>
</sc-data-set-tile>